import { WasmScorer } from "./wasm-scorer";

const WASM_URL = "/cogcoin_scoring.wasm";
const BLOB_URL = "/cgsm_blob.bin";

let scorerPromise: Promise<WasmScorer> | undefined;

/**
 * Loads `cogcoin_scoring.wasm` and `cgsm_blob.bin` from the app's origin
 * (vendored at install time into `public/`) and returns a memoized
 * `WasmScorer`. Concurrent callers share the same in-flight promise.
 *
 * The first call pays the ~35 MB blob download. After that the result
 * is cached for the lifetime of the page.
 */
export function getScorer(): Promise<WasmScorer> {
  scorerPromise ??= WasmScorer.fromStreams(fetch(WASM_URL), fetch(BLOB_URL));
  return scorerPromise;
}

/// Test hook — drops the cached promise so the next `getScorer()` reloads.
export function resetScorerForTests(): void {
  scorerPromise = undefined;
}
